import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(encounterId: string): Promise<Record<string, string>> {
    const url = this.common.constructPath(
      `/patient-previsit/payors/${encounterId}`,
    );
    return this.common.getJSON(url);
  }
}
